import ufeApi from 'services/api/ufeApi';
import languageLocaleUtils from 'utils/LanguageLocale';
import { CHANNELS } from 'constants/Channels';

const { getCurrentCountry, getCurrentLanguage } = languageLocaleUtils;

function getBuyPageData({ path }) {
    const match = /buy\/(.+)/.exec(path.replace(/\/+$/, ''));

    if (!match) {
        return Promise.reject(new Error('Invalid buy page path'));
    }

    const seoName = match[1].substring(match[1].lastIndexOf('/') + 1);
    const options = {
        method: 'GET',
        country: getCurrentCountry(),
        language: getCurrentLanguage(),
        channel: CHANNELS.RWD
    };

    return ufeApi.makeRequest(`/api/util/buyPages/${seoName}/seoName`, options);
}

export default getBuyPageData;
